module.exports = __webpack_public_path__ + "static/img/kuang_lab_icon.png";